import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-cream" data-id="element-213" data-mp="1mzivf8h58roa">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-214" data-mp="1r140w8rcm3og">
        <Reveal className="text-center" data-id="element-215" data-mp="1qz9k96n40xq6">
          <p className="text-[0.62rem] font-extrabold uppercase tracking-[0.24em] text-coral sm:text-xs" data-id="element-216" data-mp="1d0tbzb9lmz5x">
            Lo que dicen quienes ya empezaron
          </p>
          <h2 id="testimonios" className="mt-0.5 font-display text-lg font-black uppercase leading-tight text-ink sm:text-2xl lg:text-3xl" data-id="element-217" data-mp="1416bqsslvzeg">
            De cero a leer sus primeras palabras en Hangul
          </h2>
        </Reveal>

        <ul className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-218" data-mp="2yfz14a2wbtxy">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-blush bg-white p-3.5" data-id="element-219" data-mp="32egal09shgij" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-220" data-mp="34re09gc7k8vs">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-221" data-mp="34qm526miwd61">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-gold text-gold" data-id="element-222" data-mp="2c2girfftmg43" data-mpi={s} />)}
                </div>
                <QuoteIcon size={15} className="text-blush" aria-hidden="true" data-id="element-223" data-mp="274oucvedxc4n" />
              </div>
              <p className="mt-1.5 font-body text-[0.76rem] leading-snug text-ink sm:text-[0.8rem]" data-id="element-224" data-mp="2m1xo1vr5urzj">
                “{item.text}”
              </p>
              <div className="mt-auto pt-2.5" data-id="element-225" data-mp="2h45yv9hwhjz1">
                <p className="font-display text-sm font-black uppercase text-coral" data-id="element-226" data-mp="19m3zpr1h2rs">
                  {item.name}
                </p>
                <p className="text-[0.68rem] text-slate sm:text-[0.72rem]" data-id="element-227" data-mp="3sgoxinucnl56">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-4 flex justify-center" data-id="element-228" data-mp="8fydfzae0uyi">
          <CtaButton size="lg" data-id="element-229" data-mp="de9mi7suz1fo">QUIERO EMPEZAR HOY DESDE CERO</CtaButton>
        </Reveal>
      </div>
    </section>;
}